import ScoringRules from "../../../components/scoring-rules/scoring-rules";
import Page from "../../page";

const ScoringRulesPage = () => {
  return (
    <Page>
      <ScoringRules />
    </Page>
  );
};

export default ScoringRulesPage;
